/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c3d9d0a0 (Wed Sep 23 18:58:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  Address,
  AddressFromJSON,
  AddressToJSON,
  ProgramStatus,
  ProgramType,
} from './'

/**
 *
 * @export
 * @interface ProgramUpdate
 */
export interface ProgramUpdate {
  /**
   * The unique identifier assigned by the system when a program is first created.
   * @type number
   * @memberof ProgramUpdate
   */
  programsKey: number
  /**
   *
   * @type ProgramType
   * @memberof ProgramUpdate
   */
  type?: ProgramType
  /**
   *
   * @type ProgramStatus
   * @memberof ProgramUpdate
   */
  status: ProgramStatus
  /**
   * The hideFromPublicSearch prevents a program from being displayed on the marketing site.
   * @type boolean
   * @memberof ProgramUpdate
   */
  hideFromPublicSearch?: boolean
  /**
   * The contractual model name for a tutor configured at program level.
   * @type string
   * @memberof ProgramUpdate
   */
  tutorModel?: string
  /**
   * **DEPRECATED - Use semesterOneStartDate** The starting date for the program in date format: `yyyy-MM-dd`.
   * @type Date
   * @memberof ProgramUpdate
   */
  startDate?: Date
  /**
   * The starting date for the program's first semester in date format: `yyyy-MM-dd`.
   * @type Date
   * @memberof ProgramUpdate
   */
  semesterOneStartDate: Date
  /**
   * The starting date for the program's second semester in date format: `yyyy-MM-dd`.
   * @type Date
   * @memberof ProgramUpdate
   */
  semesterTwoStartDate: Date
  /**
   * The starting time for the program using ISO standard 24 hour format: `hh:mm`.
   * @type string
   * @memberof ProgramUpdate
   */
  startTime: string
  /**
   * The ending time for the program using ISO standard 24 hour format: `hh:mm`.
   * @type string
   * @memberof ProgramUpdate
   */
  endTime: string
  /**
   * The day of the week the program is available. Where 1 is Monday and 7 is Sunday
   * @type number
   * @memberof ProgramUpdate
   */
  dayOfTheWeek: number
  /**
   * Unique identifier of the actor for the Program Director
   * @type number
   * @memberof ProgramUpdate
   */
  directorActorId?: number
  /**
   * Unique identifier of the actor for the program's assigned tutor.
   * @type number
   * @memberof ProgramUpdate
   */
  tutorActorId?: number
  /**
   *
   * @type {Array<number>}
   * @memberof ProgramUpdate
   */
  tutorActorIds?: Array<number>
  /**
   * The maximum number of students allowed in a program.
   * @type number
   * @memberof ProgramUpdate
   */
  capacity?: number
  /**
   * **DEPRECATED** Program membership fees.
   * @type string
   * @memberof ProgramUpdate
   */
  membershipFee?: string
  /**
   * Program application fees.
   * @type string
   * @memberof ProgramUpdate
   */
  applicationFee?: string
  /**
   * Program enrollment fees.
   * @type string
   * @memberof ProgramUpdate
   */
  enrollmentFee?: string
  /**
   * Program supply first student fee.
   * @type string
   * @memberof ProgramUpdate
   */
  supplyFeeFirstStudent?: string
  /**
   * Program supply additional students fees.
   * @type string
   * @memberof ProgramUpdate
   */
  supplyFeeAdditionalStudent?: string
  /**
   * Program tuition fees.
   * @type string
   * @memberof ProgramUpdate
   */
  tuition?: string
  /**
   * Program local first student fee.
   * @type string
   * @memberof ProgramUpdate
   */
  localFeeFirstStudent?: string
  /**
   * Program facility first student fee.
   * @type string
   * @memberof ProgramUpdate
   */
  facilityFeeFirstStudent?: string
  /**
   * Any other miscellaneous program First student fee.
   * @type string
   * @memberof ProgramUpdate
   */
  miscFeeFirstStudent?: string
  /**
   * Program local Additional students fees.
   * @type string
   * @memberof ProgramUpdate
   */
  localFeeAdditionalStudent?: string
  /**
   * Program facility Additional students fees.
   * @type string
   * @memberof ProgramUpdate
   */
  facilityFeeAdditionalStudent?: string
  /**
   * Any other miscellaneous program Additional student fees.
   * @type string
   * @memberof ProgramUpdate
   */
  miscFeeAdditionalStudent?: string
  /**
   * **DEPRECATED** Any other miscellaneous program fees.
   * @type string
   * @memberof ProgramUpdate
   */
  miscFee2?: string
  /**
   * The percentage of fees given to the tutor. Must be a number from 0 to 100.
   * @type string
   * @memberof ProgramUpdate
   */
  subLicensedTutorPercentage?: string
  /**
   * A discount to subsequent application fees when more than one student applies to the same program.
   * @type string
   * @memberof ProgramUpdate
   */
  multiStudentApplicationDiscount?: string
  /**
   * The fee a director pays CC Home Office per student for the first semester for the first student in their program.
   * @type string
   * @memberof ProgramUpdate
   */
  semesterOneLicensingFee?: string
  /**
   * The fee a director pays CC Home Office per student for the first semester for the second+ students in their program.
   * @type string
   * @memberof ProgramUpdate
   */
  discountSemesterOneLicensingFee?: string
  /**
   * The fee a director pays CC Home Office per student for the second semester for the first student in their program..
   * @type string
   * @memberof ProgramUpdate
   */
  semesterTwoLicensingFee?: string
  /**
   * The fee a director pays CC Home Office per student for the second semester for the second+ students in their program.
   * @type string
   * @memberof ProgramUpdate
   */
  discountSemesterTwoLicensingFee?: string
  /**
   * The invitation fee per student invitation
   * @type string
   * @memberof ProgramUpdate
   */
  invitationFee?: string
  /**
   * The discount invitation fee per applied to invitation fee
   * @type string
   * @memberof ProgramUpdate
   */
  discountInvitationFee?: string
  /**
   * LCD program tutor semester one first students licensing fees
   * @type string
   * @memberof ProgramUpdate
   */
  tutorS1FirstStudentLicFee?: string
  /**
   * LCD program tutor semester two first students licensing fees.
   * @type string
   * @memberof ProgramUpdate
   */
  tutorS2FirstStudentLicFee?: string
  /**
   * LCD program tutor semester one additional students licensing fees.
   * @type string
   * @memberof ProgramUpdate
   */
  tutorS1AdditionalStudentLicFee?: string
  /**
   * LCD program tutor semester two additional students licensing fees.
   * @type string
   * @memberof ProgramUpdate
   */
  tutorS2AdditionalStudentLicFee?: string
  /**
   * The percentage of fees given to the LCD program tutor. Must be a number from 0 to 100.
   * @type string
   * @memberof ProgramUpdate
   */
  lcdTutorPercentage?: string
  /**
   * Id of the community in which this program is offered.
   * @type number
   * @memberof ProgramUpdate
   */
  communityId: number
  /**
   *
   * @type Address
   * @memberof ProgramUpdate
   */
  address: Address
  /**
   * Phone number for the director of the program.
   * @type string
   * @memberof ProgramUpdate
   */
  directorPhone?: string
}

export function ProgramUpdateFromJSON(json: any): ProgramUpdate {
  return ProgramUpdateFromJSONTyped(json, false)
}

export function ProgramUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProgramUpdate {
  if (json === undefined || json === null) {
    return json
  }
  return {
    programsKey: json['programsKey'],
    type: !exists(json, 'type') ? undefined : json['type'],
    status: json['status'],
    hideFromPublicSearch: !exists(json, 'hideFromPublicSearch')
      ? undefined
      : json['hideFromPublicSearch'],
    tutorModel: !exists(json, 'tutorModel') ? undefined : json['tutorModel'],
    startDate: !exists(json, 'startDate')
      ? undefined
      : new Date(json['startDate']),
    semesterOneStartDate: new Date(json['semesterOneStartDate']),
    semesterTwoStartDate: new Date(json['semesterTwoStartDate']),
    startTime: json['startTime'],
    endTime: json['endTime'],
    dayOfTheWeek: json['dayOfTheWeek'],
    directorActorId: !exists(json, 'directorActorId')
      ? undefined
      : json['directorActorId'],
    tutorActorId: !exists(json, 'tutorActorId')
      ? undefined
      : json['tutorActorId'],
    tutorActorIds: !exists(json, 'tutorActorIds')
      ? undefined
      : json['tutorActorIds'],
    capacity: !exists(json, 'capacity') ? undefined : json['capacity'],
    membershipFee: !exists(json, 'membershipFee')
      ? undefined
      : json['membershipFee'],
    applicationFee: !exists(json, 'applicationFee')
      ? undefined
      : json['applicationFee'],
    enrollmentFee: !exists(json, 'enrollmentFee')
      ? undefined
      : json['enrollmentFee'],
    supplyFeeFirstStudent: !exists(json, 'supplyFeeFirstStudent')
      ? undefined
      : json['supplyFeeFirstStudent'],
    supplyFeeAdditionalStudent: !exists(json, 'supplyFeeAdditionalStudent')
      ? undefined
      : json['supplyFeeAdditionalStudent'],
    tuition: !exists(json, 'tuition') ? undefined : json['tuition'],
    localFeeFirstStudent: !exists(json, 'localFeeFirstStudent')
      ? undefined
      : json['localFeeFirstStudent'],
    facilityFeeFirstStudent: !exists(json, 'facilityFeeFirstStudent')
      ? undefined
      : json['facilityFeeFirstStudent'],
    miscFeeFirstStudent: !exists(json, 'miscFeeFirstStudent')
      ? undefined
      : json['miscFeeFirstStudent'],
    localFeeAdditionalStudent: !exists(json, 'localFeeAdditionalStudent')
      ? undefined
      : json['localFeeAdditionalStudent'],
    facilityFeeAdditionalStudent: !exists(json, 'facilityFeeAdditionalStudent')
      ? undefined
      : json['facilityFeeAdditionalStudent'],
    miscFeeAdditionalStudent: !exists(json, 'miscFeeAdditionalStudent')
      ? undefined
      : json['miscFeeAdditionalStudent'],
    miscFee2: !exists(json, 'miscFee2') ? undefined : json['miscFee2'],
    subLicensedTutorPercentage: !exists(json, 'subLicensedTutorPercentage')
      ? undefined
      : json['subLicensedTutorPercentage'],
    multiStudentApplicationDiscount: !exists(
      json,
      'multiStudentApplicationDiscount'
    )
      ? undefined
      : json['multiStudentApplicationDiscount'],
    semesterOneLicensingFee: !exists(json, 'semesterOneLicensingFee')
      ? undefined
      : json['semesterOneLicensingFee'],
    discountSemesterOneLicensingFee: !exists(
      json,
      'discountSemesterOneLicensingFee'
    )
      ? undefined
      : json['discountSemesterOneLicensingFee'],
    semesterTwoLicensingFee: !exists(json, 'semesterTwoLicensingFee')
      ? undefined
      : json['semesterTwoLicensingFee'],
    discountSemesterTwoLicensingFee: !exists(
      json,
      'discountSemesterTwoLicensingFee'
    )
      ? undefined
      : json['discountSemesterTwoLicensingFee'],
    invitationFee: !exists(json, 'invitationFee')
      ? undefined
      : json['invitationFee'],
    discountInvitationFee: !exists(json, 'discountInvitationFee')
      ? undefined
      : json['discountInvitationFee'],
    tutorS1FirstStudentLicFee: !exists(json, 'tutorS1FirstStudentLicFee')
      ? undefined
      : json['tutorS1FirstStudentLicFee'],
    tutorS2FirstStudentLicFee: !exists(json, 'tutorS2FirstStudentLicFee')
      ? undefined
      : json['tutorS2FirstStudentLicFee'],
    tutorS1AdditionalStudentLicFee: !exists(
      json,
      'tutorS1AdditionalStudentLicFee'
    )
      ? undefined
      : json['tutorS1AdditionalStudentLicFee'],
    tutorS2AdditionalStudentLicFee: !exists(
      json,
      'tutorS2AdditionalStudentLicFee'
    )
      ? undefined
      : json['tutorS2AdditionalStudentLicFee'],
    lcdTutorPercentage: !exists(json, 'lcdTutorPercentage')
      ? undefined
      : json['lcdTutorPercentage'],
    communityId: json['communityId'],
    address: AddressFromJSON(json['address']),
    directorPhone: !exists(json, 'directorPhone')
      ? undefined
      : json['directorPhone'],
  }
}

export function ProgramUpdateToJSON(value?: ProgramUpdate | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    programsKey: value.programsKey,
    type: value.type,
    status: value.status,
    hideFromPublicSearch: value.hideFromPublicSearch,
    tutorModel: value.tutorModel,
    startDate:
      value.startDate === undefined
        ? undefined
        : value.startDate.toISOString().substr(0, 10),
    semesterOneStartDate: value.semesterOneStartDate
      .toISOString()
      .substr(0, 10),
    semesterTwoStartDate: value.semesterTwoStartDate
      .toISOString()
      .substr(0, 10),
    startTime: value.startTime,
    endTime: value.endTime,
    dayOfTheWeek: value.dayOfTheWeek,
    directorActorId: value.directorActorId,
    tutorActorId: value.tutorActorId,
    tutorActorIds: value.tutorActorIds,
    capacity: value.capacity,
    membershipFee: value.membershipFee,
    applicationFee: value.applicationFee,
    enrollmentFee: value.enrollmentFee,
    supplyFeeFirstStudent: value.supplyFeeFirstStudent,
    supplyFeeAdditionalStudent: value.supplyFeeAdditionalStudent,
    tuition: value.tuition,
    localFeeFirstStudent: value.localFeeFirstStudent,
    facilityFeeFirstStudent: value.facilityFeeFirstStudent,
    miscFeeFirstStudent: value.miscFeeFirstStudent,
    localFeeAdditionalStudent: value.localFeeAdditionalStudent,
    facilityFeeAdditionalStudent: value.facilityFeeAdditionalStudent,
    miscFeeAdditionalStudent: value.miscFeeAdditionalStudent,
    miscFee2: value.miscFee2,
    subLicensedTutorPercentage: value.subLicensedTutorPercentage,
    multiStudentApplicationDiscount: value.multiStudentApplicationDiscount,
    semesterOneLicensingFee: value.semesterOneLicensingFee,
    discountSemesterOneLicensingFee: value.discountSemesterOneLicensingFee,
    semesterTwoLicensingFee: value.semesterTwoLicensingFee,
    discountSemesterTwoLicensingFee: value.discountSemesterTwoLicensingFee,
    invitationFee: value.invitationFee,
    discountInvitationFee: value.discountInvitationFee,
    tutorS1FirstStudentLicFee: value.tutorS1FirstStudentLicFee,
    tutorS2FirstStudentLicFee: value.tutorS2FirstStudentLicFee,
    tutorS1AdditionalStudentLicFee: value.tutorS1AdditionalStudentLicFee,
    tutorS2AdditionalStudentLicFee: value.tutorS2AdditionalStudentLicFee,
    lcdTutorPercentage: value.lcdTutorPercentage,
    communityId: value.communityId,
    address: AddressToJSON(value.address),
    directorPhone: value.directorPhone,
  }
}
